export default "__VITE_ASSET__CXQC_IYW__"